import { Button } from "@mui/material";
import { PlusIcon } from "app/icons";
import React from "react";

import { useStyles } from "./styles";

type Props = {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
};

export const AddButton = ({ label, onClick, disabled }: Props) => {
  const styles = useStyles();

  return (
    <Button
      variant="contained"
      className={styles.button}
      endIcon={<PlusIcon />}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};
